const WhyChooseUs = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4 font-['Poppins']">
            Why Homeowners Choose Our Platform
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We connect you directly with vetted local contractors who deliver exceptional work at fair prices — no middleman markups, no hidden fees
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <img
              src="https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/81f336484cf92443c2088d283b202d22.jpeg"
              alt="Professional Roofing Contractors"
              className="rounded-2xl shadow-xl w-full h-96 object-cover object-top"
            />
          </div>
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">Vetted Pros, Fair Pricing, Zero Hassle</h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Every contractor in our network has been thoroughly vetted for licensing, insurance, quality workmanship, and fair pricing. We only match you with pros who have proven track records and excellent customer ratings.
            </p>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Our AI-powered instant estimate system gives you accurate pricing in seconds, not days. Then we connect you directly with local contractors who can deliver quality work without the traditional industry markups that add thousands to your project cost.
            </p>
            <ul className="space-y-3">
              <li className="flex items-start">
                <i className="ri-check-line text-[#2B5BA6] text-xl mr-3 mt-0.5"></i>
                <span className="text-gray-700 text-sm">All contractors fully licensed and insured</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#2B5BA6] text-xl mr-3 mt-0.5"></i>
                <span className="text-gray-700 text-sm">Verified customer reviews and ratings</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#2B5BA6] text-xl mr-3 mt-0.5"></i>
                <span className="text-gray-700 text-sm">Transparent pricing with no hidden fees</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#2B5BA6] text-xl mr-3 mt-0.5"></i>
                <span className="text-gray-700 text-sm">Quality workmanship guarantees</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h3 className="text-3xl font-bold text-gray-900 mb-6">Keep $10,000+ on Every Project</h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Traditional roofing companies charge massive markups to cover expensive marketing, sales commissions, and overhead. These costs get passed directly to you — often adding $8,000-$12,000 to your final bill.
            </p>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Our platform eliminates these unnecessary costs. You get instant AI-powered estimates and direct connections to quality pros who charge fair prices. The work quality is the same or better, but you keep thousands more in your pocket.
            </p>
            <div className="bg-gradient-to-r from-[#4A90E2]/10 to-[#2B5BA6]/10 rounded-xl p-6">
              <div className="flex items-center space-x-4 mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#2B5BA6] rounded-full">
                  <i className="ri-money-dollar-circle-line text-2xl text-white"></i>
                </div>
                <div>
                  <p className="text-2xl font-bold text-[#2B5BA6]">Average Savings: $10,000+</p>
                  <p className="text-sm text-gray-600">Compared to traditional roofing companies</p>
                </div>
              </div>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-center">
                  <i className="ri-checkbox-circle-fill text-green-600 mr-2"></i>
                  <span>Complete roof replacement: Keep $8,000 - $12,000 more</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-checkbox-circle-fill text-green-600 mr-2"></i>
                  <span>Insurance claim projects: Keep $9,000 - $11,500 more</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-checkbox-circle-fill text-green-600 mr-2"></i>
                  <span>Premium materials upgrade: Keep $10,000 - $13,000 more</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="order-1 lg:order-2">
            <img
              src="https://public.readdy.ai/ai/img_res/b22289f808a8922af9f022c3c03dd38c.jpg"
              alt="Quality Roof Replacement"
              className="rounded-2xl shadow-xl w-full h-96 object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
